import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75bc46d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "offcanvas offcanvas-start",
  tabindex: "-1",
  id: "offcanvasExample",
  "aria-labelledby": "offcanvasExampleLabel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "offcanvas-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Estrategia Cargo"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "offcanvas",
    "aria-label": "Close"
  })
], -1))
const _hoisted_3 = { class: "offcanvas-body d-flex flex-column gap-2" }
const _hoisted_4 = {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  href: "#",
  "aria-expanded": "false"
}
const _hoisted_5 = {
  class: "dropdown-menu",
  style: {"cursor":"pointer"}
}
const _hoisted_6 = { class: "dropdown-inner" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "dropdown-item" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item disabled",
  "aria-disabled": "true"
}, " Sin subprogramas ", -1))
const _hoisted_11 = [
  _hoisted_10
]

import { usePopupStore } from '@/store/PopupStore';
import { ref, watch, computed, onMounted } from 'vue'
import axios from 'axios';
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const store = usePopupStore()
const dUrl = UrlGlobal()
const userStore = userGlobalStore()

const usuario = ref<any[]>([]);
const perfil = ref('')
onMounted(async () => {
  const responseO = await axios.get(dUrl.urlGlobal + `/api/seguser/filter?nombre_usuario=${userStore.globalUser}`)
  usuario.value = responseO.data
  perfil.value = usuario.value[0]?.perfil
})

const programas = ref<any[]>([]);
const cargarProgramas = async (perfil: string) => {
  try {
    const response = await axios.post(dUrl.urlGlobal + "/api/procesos_subprogramas", {
      perfil: perfil,
    });
    programas.value = response.data;
    console.log(programas.value)
  } catch (error) {
    console.error("Error cargando programas:", error);
  }
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (cargarProgramas(perfil.value))),
      "data-bs-toggle": "offcanvas",
      href: "#offcanvasExample",
      role: "button",
      "aria-controls": "offcanvasExample",
      style: {"color":"white","border":"none","border-radius":"5px"}
    }, " ☰ "),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programas.value, (programa, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "btn-group dropend",
            key: index
          }, [
            _createElementVNode("a", _hoisted_4, _toDisplayString(programa.proceso), 1),
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programa.subprogramas, (sub, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    onClick: ($event: any) => (_unref(store).openPopup(sub.programa))
                  }, [
                    _createElementVNode("a", _hoisted_8, _toDisplayString(sub.descripcion), 1)
                  ], 8, _hoisted_7))
                }), 128)),
                (programa.subprogramas.length === 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, _hoisted_11))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})